class ProductRequestForm {
  constructor(
    container,
    isB2B,
    companyName,
    firstName,
    lastName,
    email,
    sku,
    productTitle
  ) {
    this.container = container;
    this.isB2B = isB2B;
    this.companyName = companyName;
    this.firstName = firstName;
    this.lastName = lastName;
    this.email = email;
    this.sku = sku;
    this.productTitle = productTitle;

    if (this.container) {
      this.initObserver();
    }
  }

  initObserver() {
    this.observer = new MutationObserver(() => this.checkForShadowRoot());
    this.observer.observe(this.container, { childList: true, subtree: true });
  }

  checkForShadowRoot() {
    // Remove container if not b2b customer
    if (this.isB2B !== 'true') {
      this.observer.disconnect();
      this.container.remove();
      return;
    }

    const shopifyFormsEmbed = this.container.querySelector(
      'shopify-forms-embed'
    );
    if (!shopifyFormsEmbed || !shopifyFormsEmbed.shadowRoot) return;

    // Stop observing the container
    this.observer.disconnect();

    // Now observe the shadow DOM for form elements
    this.shadowObserver = new MutationObserver(() => this.updateForm());
    this.shadowObserver.observe(shopifyFormsEmbed.shadowRoot, {
      childList: true,
      subtree: true,
    });

    // Try immediately in case form is already there
    this.updateForm();
  }

  updateForm() {
    const shopifyFormsEmbed = this.container.querySelector(
      'shopify-forms-embed'
    );
    const formsShadowRoot = shopifyFormsEmbed?.shadowRoot;
    if (!formsShadowRoot) return;

    const companyNameInput = formsShadowRoot.querySelector('input#company_name');
    const firstNameInput = formsShadowRoot.querySelector('input#first_name');
    const lastNameInput = formsShadowRoot.querySelector('input#last_name');
    const emailInput = formsShadowRoot.querySelector('input#email');
    const skuInput = formsShadowRoot.querySelector('input#custom\\#sku');
    const productTitleInput = formsShadowRoot.querySelector('input#custom\\#product_title');

    // Wait until the form elements are available in the shadow DOM
    if (
      !companyNameInput ||
      !firstNameInput ||
      !lastNameInput ||
      !emailInput ||
      !skuInput ||
      !productTitleInput
    )
      return;

    // Stop observing the shadow DOM
    this.shadowObserver?.disconnect();

    const companyNameContainer = companyNameInput.parentElement;
    if (companyNameContainer) {
      companyNameContainer.style.display = 'none';
    }
    companyNameInput.value = this.companyName || '';
    companyNameInput.dispatchEvent(new Event('input', { bubbles: true }));
    companyNameInput.dispatchEvent(new Event('change', { bubbles: true }));

    const firstNameContainer = firstNameInput.parentElement;
    if (firstNameContainer) {
      firstNameContainer.style.display = 'none';
    }
    firstNameInput.value = this.firstName;
    firstNameInput.dispatchEvent(new Event('input', { bubbles: true }));
    firstNameInput.dispatchEvent(new Event('change', { bubbles: true }));

    const lastNameContainer = lastNameInput.parentElement;
    if (lastNameContainer) {
      lastNameContainer.style.display = 'none';
    }
    lastNameInput.value = this.lastName;
    lastNameInput.dispatchEvent(new Event('input', { bubbles: true }));
    lastNameInput.dispatchEvent(new Event('change', { bubbles: true }));

    if (this.email) {
      const emailContainer = emailInput.parentElement;
      if (emailContainer) {
        emailContainer.style.display = 'none';
      }
      emailInput.value = this.email;
      emailInput.dispatchEvent(new Event('input', { bubbles: true }));
      emailInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    const skuContainer = skuInput.parentElement;
    if (skuContainer) {
      skuContainer.style.display = 'none';
    }
    skuInput.value = this.sku;
    skuInput.dispatchEvent(new Event('input', { bubbles: true }));
    skuInput.dispatchEvent(new Event('change', { bubbles: true }));

    const productTitleContainer = productTitleInput.parentElement;
    if (productTitleContainer) {
      productTitleContainer.style.display = 'none';
    }
    productTitleInput.value = this.productTitle;
    productTitleInput.dispatchEvent(new Event('input', { bubbles: true }));
    productTitleInput.dispatchEvent(new Event('change', { bubbles: true }));
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const scriptTag = document.querySelector('script[src*="product-request.js"]');
  const formsId = scriptTag?.dataset.formsId;
  const isB2B = scriptTag?.dataset.customerIsB2b;
  const companyName = scriptTag?.dataset.companyName;
  const firstName = scriptTag?.dataset.firstName;
  const lastName = scriptTag?.dataset.lastName;
  const email = scriptTag?.dataset.customerMail;
  const sku = scriptTag?.dataset.sku;
  const productTitle = scriptTag?.dataset.productTitle;

  if (!formsId) return;

  const productRequestForms = document.querySelectorAll(
    `div[data-forms-id="forms-root-${formsId}"]`
  );

  productRequestForms.forEach((container) => {
    new ProductRequestForm(
      container,
      isB2B,
      companyName,
      firstName,
      lastName,
      email,
      sku,
      productTitle
    );
  });
});
